const foodcourtReducer = (state=[],{type,data}) => {
    switch(type) {
        case 'SET_FOODCOURT':
            return data;
        default: 
            return state;
    }
}

export default foodcourtReducer;